/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

      if (window.PXUTheme.jsCart) {
        window.PXUTheme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.checkMontage(cart);
        window.PXUTheme.jsAjaxCart.updateView();
        
        // Dispatch cart:updated event for product page to update delivery info
        document.dispatchEvent(new CustomEvent('cart:updated', { 
          detail: { cart: cart, action: 'remove' }
        }));
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  extractDeliveryPropertyFromDrawer: function (variantId) {
    // Skip variant_id 32206654079059
    if (variantId == 32206654079059) {
      return;
    }

    const self = this;
    
    // Get cart data to find the line number for this variant
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false
    }).then(function(cart) {
      // Find the item with matching variant_id
      let lineNumber = null;
      for (let i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id == variantId) {
          // Check if it already has the property
          if (cart.items[i].properties && cart.items[i].properties['Verfügbarkeit']) {
            return; // Already has property, skip
          }
          lineNumber = i + 1;
          break;
        }
      }

      if (!lineNumber) {
        return;
      }

      // Find the delivery-wrapper for this line item in the drawer
      const $lineItem = $(`.ajax-cart__list [data-line-item="${lineNumber}"]`);
      if (!$lineItem.length) {
        return;
      }

      const $deliveryWrapper = $lineItem.find('.delivery-wrapper');
      if (!$deliveryWrapper.length) {
        return;
      }

      const $fBlack = $deliveryWrapper.find('.f-black');
      const $fBrown = $deliveryWrapper.find('.f-brown');
      const $fGreen = $deliveryWrapper.find('.f-green, .green');

      let propertyName = 'Verfügbarkeit'; // default
      let propertyValue = '';

      // If we have f-black span, use its text as property name
      if ($fBlack.length) {
        const blackText = $fBlack.text().trim();
        // Remove colon if present
        propertyName = blackText.replace(/[:：]$/, '').trim() || 'Verfügbarkeit';
      }

      // Get value from f-brown or f-green
      if ($fBrown.length) {
        propertyValue = $fBrown.text().trim();
      } else if ($fGreen.length) {
        propertyValue = $fGreen.text().trim();
      } else {
        // If no value span, get all text from delivery-wrapper except the property name
        const allText = $deliveryWrapper.text().trim();
        const nameIndex = allText.indexOf(propertyName);
        if (nameIndex !== -1) {
          propertyValue = allText.substring(nameIndex + propertyName.length).replace(/^[:：\s\n\r]+/, '').trim();
        } else {
          propertyValue = allText;
        }
      }

      if (!propertyValue) {
        return;
      }

      // Get existing properties from cart item
      const cartItem = cart.items[lineNumber - 1];
      const existingProperties = cartItem.properties || {};
      
      // Add delivery property
      existingProperties[propertyName] = propertyValue;

      // Update the cart item with the property
      $.ajax({
        url: '/cart/change.js',
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          line: lineNumber,
          properties: existingProperties
        })
      }).then(function() {
        // Refresh the cart view
        self.updateView();
      });
    });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

    if (this.recipientForm) {
      this.recipientForm.classList.remove('recipient-form--has-errors');
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      const self = this;
      
      // Disable button immediately
      $addToCartBtn
        .attr('disabled', 'disabled')
        .addClass('disabled');

      $addToCartBtn.find('span')
        .removeClass("fadeInDown")
        .addClass('animated zoomOut');
      
      // Get variant ID and quantity from form
      const variantId = $addToCartForm.find('[name="id"]').val();
      const addQty = parseInt($addToCartForm.find('[name="quantity"]').val()) || 1;
      
      // First, get current cart to check existing quantities
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false
      }).then(async function(cart) {
        // Calculate current quantity of this variant in cart
        let currentCartQty = 0;
        let existingLineKey = null;
        let existingLineNumber = null;

        for (let i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id == variantId) {
            currentCartQty += cart.items[i].quantity;
            // Store the first line item's key for potential update
            if (!existingLineKey) {
              existingLineKey = cart.items[i].key;
              existingLineNumber = i + 1;
            }
          }
        }

        // Get inventory data from the page (stored in product.liquid script or collection thumbnails)
        let inventoryQty = 0;
        let inventoryPolicy = 'deny';
        let slowDeliveryText = '';
        let fastDeliveryText = '';
        let foundDataInDOM = false;

        // STEP 1: Try to get data from delivery data scripts on page
        // On product pages: single script with all variant data
        // On collection pages: multiple scripts, one per product
        const deliveryDataScripts = document.querySelectorAll('[data-variant-delivery-data]');
        for (const deliveryDataScript of deliveryDataScripts) {
          try {
            const deliveryData = JSON.parse(deliveryDataScript.textContent);
            if (deliveryData.variants && deliveryData.variants[variantId]) {
              const variantData = deliveryData.variants[variantId];
              slowDeliveryText = variantData.status === 'incoming' ? variantData.text : '';
              fastDeliveryText = variantData.status === 'available' ? variantData.text : '';
              foundDataInDOM = true;

              // Also get inventory data from the same source (collection page format)
              if (typeof variantData.inventory_quantity !== 'undefined') {
                inventoryQty = variantData.inventory_quantity;
                inventoryPolicy = variantData.inventory_policy || 'deny';
              }

              // Get metafield from product level if status is incoming but text is default
              if (variantData.status === 'incoming' && deliveryData.metafield && !slowDeliveryText) {
                slowDeliveryText = deliveryData.metafield;
              }

              // console.log('📦 Found delivery data in DOM for variant', variantId, {
              //   status: variantData.status,
              //   text: variantData.text,
              //   inventory: inventoryQty,
              //   policy: inventoryPolicy
              // });

              break; // Found the variant, stop searching
            }
            if (deliveryData.translations && !fastDeliveryText) {
              fastDeliveryText = (deliveryData.translations.available || 'Auf Lager.') + ' ' + (deliveryData.translations.deliveryTime || 'Lieferzeit 1-4 Werktage');
            }
          } catch(e) {
            console.warn('Error parsing delivery data:', e);
          }
        }

        // STEP 2: Try to get inventory from product form data attribute (product page only)
        if (!foundDataInDOM) {
          const productForm = document.querySelector('[data-variant-inventory]');
          if (productForm) {
            try {
              const inventoryData = JSON.parse(productForm.getAttribute('data-variant-inventory'));
              for (let inv of inventoryData) {
                if (inv.id == variantId) {
                  inventoryQty = inv.inventory_quantity;
                  inventoryPolicy = inv.inventory_policy;
                  break;
                }
              }
            } catch(e) {}
          }
        }

        // STEP 3: Fallback - try to get from hidden input on page (product page)
        if (!slowDeliveryText) {
          const hiddenInput = document.querySelector('#availability_delivery_time');
          if (hiddenInput && hiddenInput.value) {
            slowDeliveryText = hiddenInput.value;
          }
        }

        // STEP 3a: Storefront API fallback (for Boost collection pages where DOM data is not available)
        if (!foundDataInDOM && window.StorefrontDeliveryHelper) {
          try {
            // Get product handle from the clicked product card
            let productHandle = null;
            const $productCard = $addToCartForm.closest('[data-product-handle]');
            if ($productCard.length) {
              productHandle = $productCard.attr('data-product-handle');
            }
            // Try Boost's product card format
            if (!productHandle) {
              const $boostCard = $addToCartForm.closest('.boost-sd__product-item');
              if ($boostCard.length) {
                try {
                  const productData = JSON.parse($boostCard.attr('data-product'));
                  productHandle = productData.handle;
                } catch(e) {}
              }
            }
            // Try from variant ID
            if (!productHandle) {
              productHandle = await window.StorefrontDeliveryHelper.getProductHandleFromVariant(variantId);
            }

            if (productHandle) {
              // console.log('📡 Fetching delivery data via Storefront API for:', productHandle);
              const deliveryInfo = await window.StorefrontDeliveryHelper.getVariantDeliveryInfo(
                productHandle,
                variantId,
                fastDeliveryText || 'Auf Lager. Lieferzeit 1-4 Werktage',
                slowDeliveryText || 'Lieferzeit ca. 4 - 6 Wochen'
              );
              if (deliveryInfo) {
                if (deliveryInfo.status === 'available') {
                  fastDeliveryText = deliveryInfo.deliveryText;
                  inventoryQty = deliveryInfo.quantityAvailable || inventoryQty;
                } else if (deliveryInfo.status === 'incoming') {
                  slowDeliveryText = deliveryInfo.deliveryText;
                  inventoryPolicy = 'continue';
                }
                if (deliveryInfo.metafield && !slowDeliveryText) {
                  slowDeliveryText = deliveryInfo.metafield;
                }
                // console.log('📦 Got delivery info from Storefront API:', deliveryInfo);
              }
            }
          } catch(e) {
            // console.warn('Storefront API fallback failed:', e);
          }
        }

        // STEP 4: Final fallback for slow delivery text
        if (!slowDeliveryText) {
          slowDeliveryText = 'Lieferzeit ca. 4 - 6 Wochen';
        }

        // Ensure we have fast delivery text
        if (!fastDeliveryText) {
          fastDeliveryText = 'Auf Lager. Lieferzeit 1-4 Werktage';
        }

        // Calculate what delivery text should be used
        const totalQtyAfterAdd = currentCartQty + addQty;
        const needsSlowDelivery = totalQtyAfterAdd > inventoryQty || inventoryQty <= 0;
        const deliveryText = (needsSlowDelivery && inventoryPolicy === 'continue') ? slowDeliveryText : fastDeliveryText;
        
        // Build form data without Verfügbarkeit
        let formData = $addToCartForm.serialize();
        const formDataArray = formData.split('&');
        formData = formDataArray
          .filter(param => {
            if (param.startsWith('properties%5B') || param.startsWith('properties[')) {
              const decoded = decodeURIComponent(param);
              if (decoded.includes('Verfügbarkeit')) {
                return false;
              }
            }
            return true;
          })
          .join('&');
        
        // Add the correct delivery property
        if (deliveryText) {
          formData += '&properties%5BVerf%C3%BCgbarkeit%5D=' + encodeURIComponent(deliveryText);
        }
        
        // Function to handle success after adding to cart
        function handleAddSuccess(product) {
          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {
            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              window.PXUTheme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }
            $el.addClass('show-mini-cart');
            $addToCartBtn.find('span').removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
          }, 1000);

          window.PXUTheme.jsAjaxCart.showDrawer();
          window.PXUTheme.jsAjaxCart.updateView();
          
          // Dispatch cart:updated event for product page to update delivery info
          document.dispatchEvent(new CustomEvent('cart:updated', { 
            detail: { product: product, action: 'add' }
          }));

          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: 'html',
              async: false,
              cache: false,
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);
              }
            });
          }
        }
        
        // Function to handle error
        function handleAddError(XMLHttpRequest) {
          let response;
          try {
            response = JSON.parse(XMLHttpRequest.responseText);
          } catch(e) {
            response = { description: 'Error adding to cart' };
          }

          $('.warning').remove();

          let cartWarning;
          if (response.errors && response.errors.email) {
            if (self.recipientForm) {
              self.recipientForm.classList.add('recipient-form--has-errors');
            }
          } else {
            cartWarning = `<p class="cart-warning__message animated bounceIn">${(response.description || '').replace('All 1 ', 'All ')}</p>`;
          }

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
        
        // If we need slow delivery AND there are existing items with fast delivery, update them first
        if (needsSlowDelivery && existingLineNumber && deliveryText) {
          // Update existing item's property to slow delivery, then add the new item
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false
          }).then(function(updatedCart) {
            // Find all line items with this variant and update their properties
            let updatePromises = [];
            
            for (let i = 0; i < updatedCart.items.length; i++) {
              if (updatedCart.items[i].variant_id == variantId) {
                const item = updatedCart.items[i];
                const props = item.properties || {};
                
                // Only update if property is different
                if (props['Verfügbarkeit'] !== deliveryText) {
                  props['Verfügbarkeit'] = deliveryText;
                  
                  updatePromises.push($.ajax({
                    url: '/cart/change.js',
                    method: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify({
                      line: i + 1,
                      properties: props
                    })
                  }));
                }
              }
            }
            
            // After updating existing items, add the new one
            $.when.apply($, updatePromises).always(function() {
              $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: formData,
                success: handleAddSuccess,
                error: handleAddError
              });
            });
          });
        } else {
          // Just add to cart normally
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: formData,
            success: handleAddSuccess,
            error: handleAddError
          });
        }
        
      }).catch(function() {
        // If cart fetch fails, just add normally without the smart logic
        let formData = $addToCartForm.serialize();
        
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: formData,
          success: function(product) {
            window.PXUTheme.jsAjaxCart.showDrawer();
            window.PXUTheme.jsAjaxCart.updateView();
            
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');
          },
          error: function(xhr) {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');
          }
        });
      });
    }
  },
  updateView: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  checkMontage: function(cart){
    let bFound = false;
    let props = {};
    
    for (const item of cart.items_removed){
      if(item.sku === "Montageservice"){
        bFound = true;
        break;
      }
    }
    if (bFound==false){
      return;
    }

    for (const [idx,item] of cart.items.entries()){
      if(item.properties && item.properties['Inklusive Montage'] === "Ja"){
        props = item.properties;
        delete props["Inklusive Montage"];
        
        fetch( '/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
           line: idx + 1 ,
           properties: props
          })
        }).then(()=>{
          if (isScreenSizeLarge() || this.cart_action == 'drawer') {
            this.initializeAjaxCart();
          } else {
            this.initializeAjaxCartOnMobile();
          }
        })
      }
    }

  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;